import { fetcher, SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { LoginResponse, UserResponse } from './types';

export async function ExemptionPortalVerifyUser(clerkToken: string): Promise<{
  success: boolean;
  data?: LoginResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `portal/auth/verify-user`,
      {
        method: 'POST',
        body: {},
      },
      undefined,
      clerkToken
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Authentication failed',
      };
    }

    return {
      success: true,
      data: data as LoginResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function useExemptionPortalUserProfile(
  clerkToken: string
): Promise<{
  user: UserResponse['user'] | undefined;
  isLoading: boolean;
  error: Error | null;
  mutate: (data?: UserResponse) => Promise<UserResponse | undefined>;
}> {
  const { data, error, isLoading, mutate } = useSWR<UserResponse>(
    'portal/users/profile',
    SWRFetcher({ method: 'GET' }, undefined, clerkToken)
  );

  return {
    user: data?.user,
    isLoading,
    error,
    mutate,
  };
}
